import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';

import {IDeviceMinAvg, IOrgMinAvg} from '../';
import {environment} from '../../../../environments/environment';

import {Observable} from 'rxjs';
import {map} from 'rxjs/internal/operators';

@Injectable()
export class EventService {

  constructor(private httpClient: HttpClient) {
  }

  requestOrgMinAvg(orgToken: string, interval: number,
                   fromDate?: Date, toDate?: Date, desc?: boolean, limit?: number): Observable<IOrgMinAvg[]> {

    if (interval !== 15 && interval !== 5) {
      console.warn(`${interval} min interval does not exit.`);
      return null;
    }

    const headers = new HttpHeaders({'Authorization': `Bearer ${orgToken}`});
    const url: string = `${environment.afbV2Host}org-users/self/devices/all/events/${interval}min-avg`;

    // Set query params
    let params = new HttpParams();
    if (fromDate) {
      params = params.append('from', fromDate.toISOString());
    }
    if (toDate) {
      params = params.append('to', toDate.toISOString());
    }
    if (desc) {
      params = params.append('desc', desc.toString());
    }
    if (limit) {
      params = params.append('limit', limit.toString());
    }

    // Add header and paramemters to requestOptions
    const options = {
      headers,
      params
    };

    // Parse the response and send only data object
    return this.httpClient
      .get<{ data: IOrgMinAvg[] }>(url, options)
      .pipe(
        map(response => response.data)
      );
  }

  requestGroupMinAvg(orgToken: string, groupId: string, interval: number,
                     fromDate?: Date, toDate?: Date, desc?: boolean, limit?: number): Observable<IOrgMinAvg[]> {

    if (interval !== 15 && interval !== 5) {
      console.warn(`${interval} min interval does not exit.`);
      return null;
    }

    const headers = new HttpHeaders({'Authorization': `Bearer ${orgToken}`});
    const url: string = `${environment.afbV2Host}org-users/self/groups/${groupId}/devices/all/events/${interval}min-avg`;

    // Set query params
    let params = new HttpParams();
    if (fromDate) {
      params = params.append('from', fromDate.toISOString());
    }
    if (toDate) {
      params = params.append('to', toDate.toISOString());
    }
    if (desc) {
      params = params.append('desc', desc.toString());
    }
    if (limit) {
      params = params.append('limit', limit.toString());
    }

    // Add header and paramemters to requestOptions
    const options = {
      headers,
      params
    };

    // Parse the response and send only data object
    return this.httpClient
      .get<{ data: IOrgMinAvg[] }>(url, options)
      .pipe(
        map(response => response.data)
      );
  }


  // Generalized device type
  requestDeviceMinAvg(orgToken: string, deviceId: number, deviceType: string, interval: number,
                      fromDate?: Date, toDate?: Date, desc?: boolean, limit?: number): Observable<IDeviceMinAvg[]> {

    if (interval !== 15 && interval !== 5) {
      console.warn(`${interval} min interval does not exit.`);
      return null;
    }

    const headers = new HttpHeaders({'Authorization': `Bearer ${orgToken}`});
    const url = `${environment.afbV2Host}org-users/self/devices/${deviceType}/${deviceId}/events/${interval}min-avg`;

    // Set query params
    let params = new HttpParams();
    if (fromDate) {
      params = params.append('from', fromDate.toISOString());
    }
    if (toDate) {
      params = params.append('to', toDate.toISOString());
    }
    if (desc) {
      params = params.append('desc', desc.toString());
    }
    if (limit) {
      params = params.append('limit', limit.toString());
    }

    // Add header and paramemters to requestOptions
    const options = {
      headers,
      params
    };

    // Parse the response and send only data object
    return this.httpClient
      .get<{ data: IDeviceMinAvg[] }>(url, options)
      .pipe(
        map(response => response.data)
      );
  }
}
